import React, { useState } from 'react';

const Solutions = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="relative bg-white">
      {/* Content */}
      <div className="relative z-10 px-4 md:px-20 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className="mt-2 md:mt-2 md:mb-5 mb-2">
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#FDBD26] md:mb-3">
            Experience Farmnet App
          </h1>
          <h1 className="text-[12px] md:text-[40px] font-bold text-black">
            Reports
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:-mt-5 md:h-[700px] flex justify-center items-center cursor-pointer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745110268/image_12_woc9ha.png"
              alt="Mobile"
              className="object-cover w-[20%] h-[50%] md:w-[22%] md:h-[83%] object-center"
            />
            <div
              className="absolute inset-0 flex justify-center items-center"
              onClick={() => setShowVideo(true)}
            >
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain cursor-pointer"
              />
            </div>
          </div>

          <div className="absolute bottom-[10px] md:bottom-8 left-4 md:left-10">
            <p className="text-[12px] md:text-[40px] font-bold text-[#FDBD26]">
              Reports
            </p>
          </div>

          {/* Logo */}
          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[60px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Updated Paragraph */}
        <div className="mt-6 md:mt-8 text-black space-y-4 leading-relaxed">
          <p className="text-[8px] md:text-[32px] md:mb-10 mb-4">
            The Farmnet Mobile App provides a comprehensive Farming Reports Solution that empowers value chain stakeholders—such as farmers, buyers, input suppliers, financial institutions, and extension services—to make informed decisions through real-time data and analytics.
          </p>

          <h2 className="font-bold text-[8px] md:text-[32px] mt-6 ">
            How Value Chain Stakeholders Utilize the Farming Reports Solution
          </h2>
          <div className="md:h-5"></div>

          <ul className="list-decimal list-inside marker:font-bold space-y-2 text-[8px] md:text-[32px] text-black">
            <li><strong>Farmers:</strong> Access personalized reports on crop performance, input usage, and financial metrics, enabling them to optimize production practices and manage resources effectively.</li>
            <li><strong>Buyers and Traders:</strong> Monitor supply consistency and quality through traceable data, facilitating transparent procurement processes and fostering trust with suppliers.</li>
            <li><strong>Input Suppliers:</strong> Analyze usage patterns and demand forecasts to tailor product offerings and marketing strategies, ensuring timely and relevant supply to farmers.</li>
            <li><strong>Financial Institutions:</strong> Assess creditworthiness by reviewing historical performance data, transaction records, and risk indicators, thereby enhancing loan approval processes.</li>
            <li><strong>Extension Services:</strong> Utilize aggregated data to identify regional trends, target interventions, and provide timely advice to farmers, improving overall agricultural productivity.</li>
          </ul>

          <ul className="list-disc list-inside space-y-2 text-[8px] md:text-[32px] text-black">
            <li><strong>Enhanced Transparency:</strong> Facilitates clear communication and trust among stakeholders by providing verifiable data on agricultural activities.</li>
            <li><strong>Improved Decision-Making:</strong> Equips stakeholders with actionable insights, leading to more effective planning, resource allocation, and risk management.</li>
            <li><strong>Increased Efficiency:</strong> Streamlines operations by automating data collection and reporting processes, reducing manual efforts and errors.</li>
            <li><strong>Strengthened Partnerships:</strong> Promotes collaborative relationships through shared access to relevant data, aligning objectives and fostering mutual growth.</li>
            <li><strong>Enhanced Access to Finance:</strong> Provides financial institutions with reliable data to assess loan risks and opportunities, facilitating better access to credit for farmers.</li>
          </ul>

          <div className="md:h-5"></div>

          <p className="mt-4 text-[14px] md:text-[40px] text-black">
            The Farming Reports Solution within the Farmnet Mobile App serves as a pivotal tool in <strong>modernizing agricultural value chains.</strong> By enabling data-driven decisions, it enhances <strong>transparency, efficiency, and collaboration</strong> among all stakeholders, ultimately contributing to a more sustainable and profitable agricultural ecosystem.
          </p>
        </div>

        <div className="md:h-10 h-5"></div>
      </div>

      {/* Video Modal */}
      {showVideo && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
          <div className="relative w-full h-full">
            <button
              onClick={() => setShowVideo(false)}
              className="absolute top-2 right-4 text-white text-4xl z-50"
            >
              &times;
            </button>
            <video
              src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744223826/g5tzh6p6dojv29rjfwfj.mp4"
              controls
              autoPlay
              className="w-full h-full md:p-20  p-4 object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Solutions;
